import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { Box, Divider, Flex, Text } from "pcln-design-system";
import { useContext } from "react";
import { ChatbotDataContext } from "../../context/ChatbotDataContext.js";
import { TravelBotLogoImage } from "../../TravelBotLogoImage.js";
import { ChatMessage } from "../CustomChatMessage/index.js";
import MessageFooter from "../MessageFooter/MessageFooter.js";
import PennyChatBubble from "../PennyChatBubble/index.js";
function ShowCancelConsequencesMarker({ message, cancelConsequences }) {
    const { localCurrencyCode, localCurrencySymbol, roomCharge, taxesAndFees, subTotal, penalty, refundAmount, consequenceHeading, consequenceSubHeading, consequenceFooter, hotelFee, previousRefund, isPricelineProduct, cancellationPolicy } = cancelConsequences || {};
    const hasPenalty = parseInt(penalty.amountInLocalCurrency) > 0;
    const { setiValues } = useContext(ChatbotDataContext);
    const content = /*#__PURE__*/ jsxs(Box, {
        children: [
            consequenceHeading && /*#__PURE__*/ jsx(Text, {
                fontSize: 2,
                mb: 3,
                children: consequenceHeading
            }),
            consequenceSubHeading && /*#__PURE__*/ jsx(Text, {
                fontSize: 2,
                mb: 3,
                children: consequenceSubHeading
            }),
            !!Object.keys(cancellationPolicy || {}).length && !isPricelineProduct && /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsx(Text, {
                        bold: true,
                        fontSize: 2,
                        mb: 2,
                        children: cancellationPolicy?.label
                    }),
                    /*#__PURE__*/ jsx("ul", {
                        children: cancellationPolicy?.policyText?.map((policy, index)=>/*#__PURE__*/ jsx("li", {
                                children: policy
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ jsx(Text, {
                bold: true,
                fontSize: 2,
                mb: 2,
                children: "Payment Summary"
            }),
            /*#__PURE__*/ jsx(Divider, {}),
            roomCharge && roomCharge.amountInLocalCurrency && /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    ' ',
                    /*#__PURE__*/ jsxs(Flex, {
                        justifyContent: "space-between",
                        height: "40px",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ jsx(Text, {
                                fontSize: 1,
                                children: roomCharge?.label || 'Room Charge'
                            }),
                            /*#__PURE__*/ jsxs(Flex, {
                                children: [
                                    localCurrencySymbol && /*#__PURE__*/ jsx(Text, {
                                        fontSize: 1,
                                        children: localCurrencySymbol
                                    }),
                                    /*#__PURE__*/ jsx(Text, {
                                        fontSize: 1,
                                        children: roomCharge?.amountInLocalCurrency
                                    }),
                                    !localCurrencySymbol && /*#__PURE__*/ jsx(Text, {
                                        fontSize: 1,
                                        pl: 1,
                                        children: localCurrencyCode
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsx(Divider, {})
                ]
            }),
            taxesAndFees && taxesAndFees.amountInLocalCurrency && /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsxs(Flex, {
                        justifyContent: "space-between",
                        height: "40px",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ jsx(Text, {
                                fontSize: 1,
                                children: taxesAndFees?.label || 'Taxes and Fees'
                            }),
                            /*#__PURE__*/ jsxs(Flex, {
                                children: [
                                    localCurrencySymbol && /*#__PURE__*/ jsx(Text, {
                                        fontSize: 1,
                                        children: localCurrencySymbol
                                    }),
                                    /*#__PURE__*/ jsx(Text, {
                                        fontSize: 1,
                                        children: taxesAndFees?.amountInLocalCurrency
                                    }),
                                    !localCurrencySymbol && /*#__PURE__*/ jsx(Text, {
                                        fontSize: 1,
                                        pl: 1,
                                        children: localCurrencyCode
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsx(Divider, {})
                ]
            }),
            hotelFee && hotelFee.amountInLocalCurrency && /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsxs(Flex, {
                        justifyContent: "space-between",
                        height: "40px",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ jsx(Text, {
                                fontSize: 1,
                                children: hotelFee?.label || 'Taxes and Fees'
                            }),
                            /*#__PURE__*/ jsxs(Flex, {
                                children: [
                                    localCurrencySymbol && /*#__PURE__*/ jsx(Text, {
                                        fontSize: 1,
                                        children: localCurrencySymbol
                                    }),
                                    /*#__PURE__*/ jsx(Text, {
                                        fontSize: 1,
                                        children: hotelFee?.amountInLocalCurrency
                                    }),
                                    !localCurrencySymbol && /*#__PURE__*/ jsx(Text, {
                                        fontSize: 1,
                                        pl: 1,
                                        children: localCurrencyCode
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsx(Divider, {})
                ]
            }),
            subTotal && subTotal.amountInLocalCurrency && /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsxs(Flex, {
                        justifyContent: "space-between",
                        height: "40px",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ jsx(Text, {
                                fontSize: 1,
                                children: subTotal?.label || 'Subtotal'
                            }),
                            /*#__PURE__*/ jsxs(Flex, {
                                children: [
                                    localCurrencySymbol && /*#__PURE__*/ jsx(Text, {
                                        fontSize: 1,
                                        children: localCurrencySymbol
                                    }),
                                    /*#__PURE__*/ jsx(Text, {
                                        fontSize: 1,
                                        children: subTotal?.amountInLocalCurrency
                                    }),
                                    !localCurrencySymbol && /*#__PURE__*/ jsx(Text, {
                                        fontSize: 1,
                                        pl: 1,
                                        children: localCurrencyCode
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsx(Divider, {})
                ]
            }),
            previousRefund && previousRefund.amountInLocalCurrency && /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsxs(Flex, {
                        justifyContent: "space-between",
                        height: "40px",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ jsx(Text, {
                                fontSize: 1,
                                children: previousRefund?.label || 'Subtotal'
                            }),
                            /*#__PURE__*/ jsxs(Flex, {
                                children: [
                                    localCurrencySymbol && /*#__PURE__*/ jsx(Text, {
                                        fontSize: 1,
                                        children: localCurrencySymbol
                                    }),
                                    /*#__PURE__*/ jsx(Text, {
                                        fontSize: 1,
                                        children: previousRefund.amountInLocalCurrency
                                    }),
                                    !localCurrencySymbol && /*#__PURE__*/ jsx(Text, {
                                        fontSize: 1,
                                        pl: 1,
                                        children: localCurrencyCode
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsx(Divider, {})
                ]
            }),
            hasPenalty && /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsxs(Flex, {
                        justifyContent: "space-between",
                        height: "40px",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ jsx(Text, {
                                fontSize: 1,
                                color: "warning",
                                children: penalty?.label || 'Penalty Fee'
                            }),
                            /*#__PURE__*/ jsxs(Flex, {
                                children: [
                                    /*#__PURE__*/ jsx(Text, {
                                        fontSize: 1,
                                        color: "warning",
                                        children: "-"
                                    }),
                                    localCurrencySymbol && /*#__PURE__*/ jsx(Text, {
                                        fontSize: 1,
                                        color: "warning",
                                        children: localCurrencySymbol
                                    }),
                                    /*#__PURE__*/ jsx(Text, {
                                        fontSize: 1,
                                        color: "warning",
                                        children: penalty?.amountInLocalCurrency
                                    }),
                                    !localCurrencySymbol && /*#__PURE__*/ jsx(Text, {
                                        color: "warning",
                                        fontSize: 1,
                                        pl: 1,
                                        children: localCurrencyCode
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsx(Divider, {})
                ]
            }),
            refundAmount && refundAmount.amountInLocalCurrency && /*#__PURE__*/ jsxs(Flex, {
                justifyContent: "space-between",
                height: "40px",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ jsx(Text, {
                        fontSize: 1,
                        color: "success",
                        bold: true,
                        children: refundAmount?.label || 'Refund Amount'
                    }),
                    /*#__PURE__*/ jsxs(Flex, {
                        children: [
                            localCurrencySymbol && /*#__PURE__*/ jsx(Text, {
                                fontSize: 1,
                                color: "success",
                                bold: true,
                                children: localCurrencySymbol
                            }),
                            /*#__PURE__*/ jsx(Text, {
                                fontSize: 1,
                                color: "success",
                                bold: true,
                                children: refundAmount?.amountInLocalCurrency
                            }),
                            !localCurrencySymbol && /*#__PURE__*/ jsx(Text, {
                                color: "success",
                                fontSize: 1,
                                pl: 1,
                                bold: true,
                                children: localCurrencyCode
                            })
                        ]
                    })
                ]
            }),
            consequenceFooter && /*#__PURE__*/ jsx(Text, {
                mt: 3,
                children: consequenceFooter
            })
        ]
    });
    return /*#__PURE__*/ jsx(Fragment, {
        children: setiValues?.shouldEnablePortalUpdates ? /*#__PURE__*/ jsx(PennyChatBubble, {
            message: message,
            children: content
        }) : /*#__PURE__*/ jsx(ChatMessage, {
            ml: "",
            mb: "20px",
            mr: "",
            variation: 'initial',
            Icon: TravelBotLogoImage,
            footer: /*#__PURE__*/ jsx(MessageFooter, {}),
            message: content
        })
    });
}
export { ShowCancelConsequencesMarker as default };
